module.exports = __webpack_public_path__ + "img/rootTx-hint.aba6a38d.png";